import cn from 'classnames';

import { IConDefaultType } from '../../types';

export interface ISproutIconProps extends IConDefaultType {}

export default function SproutIcon({ color, className, size = 20, rotate, flip }: ISproutIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10.0002 17.5V10.8333M10.0002 10.8333C10.0002 11.2933 10.3736 11.6704 10.8319 11.6262C13.6719 11.3512 17.1527 9.59624 17.4761 4.16957M10.0002 10.8333V7.34499C10.0002 7.2479 10.0169 7.14999 10.0523 7.05999C11.299 3.8329 14.2848 3.3979 16.6669 3.34165C17.1273 3.3304 17.5027 3.70999 17.4752 4.16957M3.33274 2.52999C7.21983 2.8154 9.24816 5.0679 9.93108 6.51249C9.97899 6.61332 10.0002 6.72415 10.0002 6.83582V9.96249C10.0002 10.4375 9.60024 10.8187 9.12774 10.7708C3.05733 10.16 2.54608 6.16082 2.50399 3.33332C2.49733 2.87249 2.87399 2.49582 3.33358 2.52999"
          stroke={color || 'white'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </i>
  );
}
